import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueAos from 'vue-aos'
import AOS from 'aos'
import 'aos/dist/aos.css'

import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
// Vue.use(VueAos)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  created() {
    AOS.init()
  },
  render: h => h(App)
}).$mount('#app')
